var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createContext, useContext } from "react";
import { DEFAULT_APP_SIZE } from "./useAppSizeMedia";
/**
 * @private
 */
export var AppSizeContext = createContext(__assign(__assign({}, DEFAULT_APP_SIZE), { __initialized: false }));
/**
 * Gets the current app size.
 *
 * @return the current AppSize
 */
export default function useAppSize() {
    var _a = useContext(AppSizeContext), __initialized = _a.__initialized, context = __rest(_a, ["__initialized"]);
    if (!__initialized) {
        throw new Error("Attempted to use the current `AppSizeContext` without mounting the `AppSizeListener` component beforehand.");
    }
    return context;
}
//# sourceMappingURL=useAppSize.js.map